import { Dispatch, SetStateAction, useContext } from 'react';

import fileUploadIcon from '@atom/components/common/svgIcons/fileUploadIcon.svg';
import { Icon, IconButton, Menu } from '@atom/mui';
import colors from '@atom/styles/colors';
import { BudgetModal } from '@atom/types/budget';
import { BudgetTemplateType } from '@atom/utilities/endpoints';

import BudgetDetailContext from './BudgetDetailContext';
import { useBudgetBulkEditAccess } from './useBudgetBulkEditAccess';

const { MenuItem } = Menu;

type Props = {
  setActiveModal: Dispatch<SetStateAction<BudgetModal>>;
  setType: Dispatch<SetStateAction<BudgetTemplateType>>;
};

const BudgetUploadMenu = ({ setActiveModal, setType }: Props) => {
  const { parentBudgetUnit, showAuthorizedBudget } =
    useContext(BudgetDetailContext);
  const { hasBulkEditBudgetItemAccess, hasBulkEditAuthorizedBudgetAccess } =
    useBudgetBulkEditAccess(parentBudgetUnit?.actionsOnBudgetItems);

  const openBulkEdit = (templateType: BudgetTemplateType) => {
    setType(templateType);
    setActiveModal(BudgetModal.BULK_EDIT);
  };

  return showAuthorizedBudget ? (
    <Menu
      icon={
        <Icon color={colors.neutral.white}>
          <img src={fileUploadIcon} />
        </Icon>
      }
      IconButtonProps={{ tooltip: 'Upload CSV' }}
      IconProps={{
        color: colors.neutral.white,
      }}
    >
      {hasBulkEditBudgetItemAccess && (
        <MenuItem onClick={() => openBulkEdit('budgetItems')}>
          Upload Budget
        </MenuItem>
      )}
      {hasBulkEditAuthorizedBudgetAccess && (
        <MenuItem onClick={() => openBulkEdit('authorizedBudget')}>
          Upload Authorized Budget
        </MenuItem>
      )}
    </Menu>
  ) : (
    <IconButton
      tooltip="Upload CSV"
      onClick={() => openBulkEdit('budgetItems')}
    >
      <Icon color={colors.neutral.white}>
        <img src={fileUploadIcon} />
      </Icon>
    </IconButton>
  );
};

export default BudgetUploadMenu;
